
import {Company} from "@/models/company";
import {Plan} from "@/models/plan";
import {Subscription} from "@/models/subscription";
import {SubscriptionSerivce} from "@/services/subscription-service";
import Vue from "vue";
import AppCompanySubscriptionEditForm from "./CompanySubscriptionEditForm.vue";
import AppCompanySubscriptionEditRaw from "./CompanySubscriptionEditRaw.vue";

export default Vue.extend({
	data() {
		return {
			tab: 0,
		};
	},
	props: {
		company: {
			type: Object as () => Company,
			required: true
		},
		sub: {
			type: Object as () => Subscription,
			required: true
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async save() {
			if (this.tab == 1) {
				this.sub.plan = new Plan(JSON.parse(this.sub.rawMetadata));
			}
			if (this.sub.nextPaymentDate) {
				let sub = await SubscriptionSerivce.editSubscriptionPrice(this.company.id, this.sub.id, this.sub.price, this.sub.plan);
				sub = await SubscriptionSerivce.editMetadata(this.company.id, sub.id, this.sub.plan.getJson());
				sub = await SubscriptionSerivce.editSubscriptionNextPaymentDate(this.company.id, sub.id, this.sub.nextPaymentDate,this.sub.plan);
				this.$emit("sub", sub);
			}
			this.close();
		}
	},
	components: {
		AppCompanySubscriptionEditForm,
		AppCompanySubscriptionEditRaw
	}
});
